import type { BuildingDataSummaryTranslations } from "../../types/buildingDataSummary";

export const buildingDataSummary: BuildingDataSummaryTranslations = {
  title: "Building Data",
  fieldsFilled: "{confirmed} of {total} fields confirmed",
  confirmed: "Confirmed",
  pending: "Pending",
  empty: "Empty",
  conflicts: "Conflicts",
  conflictSingular: "Conflict",
  conflictRowOne: "{field}: conflicting value — review",
  conflictRowMany: "{count} fields with conflicting values — review",
  emptyRow: "{count} fields to fill",
  updated: "Updated {time}",
  openSidebar: "Open building data",
  emptyTitle: "No building data yet",
  emptyHint: "Building attributes appear here once documents are processed.",
};
